var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.453629,
    width: 59.0927,
    height: 59.0927,
    rx: 17.3802,
    fill: "#C17B31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_239_46)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.4457 11.2971H21.633C15.5062 11.2971 12.0349 14.7684 12.0349 20.8952V37.6919C12.0349 43.8187 15.5062 47.29 21.633 47.29H38.4457C44.5725 47.29 48.0278 43.8187 48.0278 37.6919V20.8952C48.0278 14.7684 44.5725 11.2971 38.4457 11.2971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_239_46)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7814 35.6703V38.3376C20.7814 38.6913 20.9219 39.0306 21.172 39.2807C21.4221 39.5308 21.7613 39.6713 22.115 39.6713H42.12C42.4737 39.6713 42.8129 39.5308 43.063 39.2807C43.3131 39.0306 43.4536 38.6913 43.4536 38.3376V27.6683C43.4536 27.3146 43.3131 26.9754 43.063 26.7253C42.8129 26.4752 42.4737 26.3347 42.12 26.3347H40.4596V28.7813C40.6423 29.0539 40.8894 29.2772 41.179 29.4316C41.4686 29.5859 41.7918 29.6665 42.12 29.6661V36.3371C41.5914 36.3401 41.0855 36.5522 40.7127 36.927C40.34 37.3019 40.1308 37.809 40.1308 38.3376H24.1122C24.1052 37.812 23.8918 37.3103 23.518 36.9407C23.1442 36.5712 22.64 36.3635 22.1144 36.3625V35.6703H20.7814Z",
    fill: "#C17B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4571 27.6683C30.4571 28.3757 30.1761 29.0542 29.6759 29.5544C29.1756 30.0546 28.4972 30.3356 27.7898 30.3356C27.0824 30.3356 26.4039 30.0546 25.9037 29.5544C25.4035 29.0542 25.1225 28.3757 25.1225 27.6683C25.1225 26.9609 25.4035 26.2824 25.9037 25.7822C26.4039 25.282 27.0824 25.001 27.7898 25.001C28.4972 25.001 29.1756 25.282 29.6759 25.7822C30.1761 26.2824 30.4571 26.9609 30.4571 27.6683Z",
    fill: "#C17B31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7873 21C17.4336 21 17.0944 21.1405 16.8443 21.3906C16.5942 21.6407 16.4536 21.98 16.4536 22.3337V33.003C16.4536 33.3567 16.5942 33.6959 16.8443 33.946C17.0944 34.1961 17.4336 34.3366 17.7873 34.3366H37.7922C38.146 34.3366 38.4852 34.1961 38.7353 33.946C38.9854 33.6959 39.1259 33.3567 39.1259 33.003V22.3337C39.1259 21.98 38.9854 21.6407 38.7353 21.3906C38.4852 21.1405 38.146 21 37.7922 21H17.7873ZM19.7865 22.3337H35.7924C35.7929 22.8637 36.0039 23.3719 36.3789 23.7465C36.7538 24.1211 37.2622 24.3315 37.7922 24.3315V31.0025C37.2635 31.0051 36.7574 31.2171 36.3846 31.592C36.0118 31.9669 35.8027 32.4743 35.8031 33.003H19.7851C19.7785 32.4773 19.5651 31.9753 19.1913 31.6057C18.8174 31.2361 18.313 31.0285 17.7873 31.0278V24.3342C18.05 24.3342 18.31 24.2824 18.5527 24.1819C18.7953 24.0813 19.0157 23.9339 19.2014 23.7481C19.3871 23.5624 19.5343 23.3418 19.6347 23.0991C19.7351 22.8564 19.7866 22.5963 19.7865 22.3337Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4985,
    height: 36.4985,
    fill: "white",
    transform: "translate(11.7506 11.2971)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_239_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.4536 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPayment);
export default __webpack_public_path__ + "static/media/bill_payment.b29ca70f6fa08d1efc21597b5c9ae637.svg";
export { ForwardRef as ReactComponent };